import React from 'react'

interface IInfoOutlineProps {
  color?: string
  size?: number
}

export const InfoOutline = ({ color = 'var(--orange500)', size = 20 }: IInfoOutlineProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9" stroke={color} strokeWidth="1.5" />
    <path d="M10 10V14M10 6V6.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
)
